import gql from 'graphql-tag';
import {serviceFields} from '../shared/fragments';

export const company = gql`
  query company($id: ID!, $orgId: ID) {
    company(id: $id) {
      id
      name
      path
      slug
      imageUrl
      bannerImageUrl
      privateMode
      githubOrgUrl
      verified
      description
      twitterUsername
      websiteUrl
      location
      following
      amIOwner
      githubAppInstalled
      azureAppInstalled
      githubAppSettingsUrl
      azureInstallationToken
      plans {
        slug
      }
      features {
        slug
      }
      tags {
        name
      }
      tools {
        ...serviceFields
      }
      jobs {
        count
      }
      stackDecisions(orgId: $orgId) {
        count
      }
      stacksList(orgId: $orgId) {
        count
      }
      members(orgId: $orgId) {
        count
      }
      privateTeams(orgId: $orgId) {
        count
      }
      followers {
        count
      }
      blogPosts {
        count
      }
      githubRepos {
        count
      }
      socialPosts {
        count
      }
      stackApps(orgId: $orgId) {
        count
      }
    }
  }
  ${serviceFields}
`;

export const companies = gql`
  query companies($after: String, $first: Int) {
    companies(first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          slug
          path
          name
          verified
          description
          imageUrl
          id
          following
          tags {
            id
            name
          }
          popularTools(first: 6) {
            edges {
              node {
                name
                id
                slug
                thumbUrl
              }
            }
          }
          jobs {
            count
          }
        }
      }
    }
  }
`;
